import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import recentlyViewedHelper from 'utils/recentlyViewedHelper';
import getPrice from 'store/price/selector/getPrice';
import getProductQuantity from 'store/product/selector/getProductQuantity';
import getPubicAssetImagePreview from 'store/publicAssetProduct/selector/getPubicAssetImagePreview';
import getCurrentProduct from 'store/publicAssetProduct/selector/getCurrentProduct';
import getPublicAssetImageDesignName from 'store/publicAssetProduct/selector/getPublicAssetImageDesignName';
import { ProductItemPreviewProps } from 'store/product/types';

const storeRecentlyViewedOperation =
  (sourceId: string, source: string, slug = '') =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const currentProduct = getCurrentProduct(store);
    const productId = currentProduct?.productId || 1;
    const quantity = getProductQuantity(store) || 1;
    const categoryId = currentProduct?.categoryId || 1;
    const productPrice = getPrice(store, categoryId, productId, quantity);
    const designName = getPublicAssetImageDesignName(store);
    const imagePreview = getPubicAssetImagePreview(store);

    const { storeRecentlyViewed } = recentlyViewedHelper();

    if (currentProduct) {
      const uniqueProductId = source + sourceId + slug;
      const item: ProductItemPreviewProps = {
        showPrice: !!productPrice,
        categoryId,
        uniqueProductId,
        productId,
        productUrl: window.location.pathname,
        productThumbnail: imagePreview,
        productName: designName || '',
        timestamp: new Date().getTime(),
      };
      storeRecentlyViewed(item);
    }
  };

export default storeRecentlyViewedOperation;
